import React from 'react';
import CardContent from '@mui/material/CardContent';

const ReportsCardContent = ({ children, paddingBottom = 2 }) => {
    return (
        <CardContent
            sx={{
                pt: 0,
                pb: paddingBottom,
                '&:last-child': {
                    paddingBottom
                },
                '& .MuiTableRow-root:last-child .MuiTableCell-root': {
                    borderBottom: 0
                }
            }}
        >
            {children}
        </CardContent>
    );
};

export default ReportsCardContent;